export const GET_INVOICES = "GET_INVOICES"
export const GET_INVOICES_LOADING = "GET_INVOICES_LOADING"
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS"
export const GET_INVOICES_ERROR = "GET_INVOICES_ERROR"

export const getInvoices = (body) => ({ type: GET_INVOICES, body })